export const STREAMING_CONFIG = {
  FPS: 12,
  BATCH_SIZE: 8,
  VERSION: 'v15',
  API_URL: process.env.REACT_APP_STREAMING_API_URL || 'https://avatar.stacqan.com/api-rtc',
  WEBSOCKET_SERVER_URL: process.env.REACT_APP_CHAT_API_VOICE || 'wss://avatar.stacqan.com',
  WEBSOCKET_PATH: '/api-voice/socket.io',
  AUTH_TOKEN: 'sk_live_h8mvwCjYP3hIzpxziW4Ey00GWfWfOtQfju13_uGAzWA',
  DEFAULT_LANGUAGE: 'en-US',
  ICE_SERVERS: [
    { urls: 'stun:stun.l.google.com:19302' },
    {
      urls: 'turn:34.135.136.47:3478',
      username: 'webrtc',
      credential: 'my_password'
    }
  ]
};
